import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  createdTsById,
  emailById,
  nameById,
  sourceById,
} from '/redux/selector/candidate.selector';

import Header from './Header';

export default connect(
  createStructuredSelector({
    name: nameById,
    email: emailById,
    source: sourceById,
    createdOn: createdTsById,
  }),
)(Header);
